import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-notfound',
    templateUrl: './notfound.component.html',
    styleUrl: './notfound.component.scss',
    imports: [CommonModule,RouterModule, ButtonModule,AvatarModule]
})

export class Notfound {}
